import { FormState} from "./FormState";
import { crearServicioHotel, NuevoServicioHotel } from "../../../services/hotelServicios";
import {parseCurrency} from "../../../utils/numberUtils";

const generarNuevoServicioHotel = (formState: FormState): NuevoServicioHotel => {
    return {
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.value,
        precioNoche: parseCurrency(formState.precioNoche.value, "$", ","),
        horaSalida: formState.horaSalida.wasTouched ? parseInt(formState.horaSalida.value) : undefined,
        minimoNoches: formState.minimoNoches.wasTouched ? parseInt(formState.minimoNoches.value) : undefined,
        maximoNoches: formState.maximoNoches.wasTouched ? parseInt(formState.maximoNoches.value) : undefined,
    }
}

export const crearNuevoServicioHotel = async (formState: FormState) => {
    const nuevoServicio = generarNuevoServicioHotel(formState);
    await crearServicioHotel(nuevoServicio);
}